<template>
  <div class="q_page">
    <div class="quanUserWrapper">
      <div class="userWrapper">
        <div class="quanfans">
          <div class="quanfans1">券粉圈</div>
          <div class="quanfans2">晒单送券币换礼品
            <span class="icon-notice"></span>
          </div>
        </div>
          <router-link to="/quan/newPaper" class="quanfansNum">
              <div class='quanfansThumb'>
                <span class="icon-thumb"></span>
              </div>
              <div class='quanfansOrder'>
                <div class="quanfansOrder1">我要晒单</div>
                <div class="quanfansOrder2">{{peopleNum}}人</div>
              </div>
          </router-link>
      </div>
  </div>
  <!--列表页-->
  <quanList></quanList>
</div>
</template>
<script type = "text/ecamscript-6">
/* eslint-disable */
import QuanList from '@/components/quan/quanList'
  export default {
    name:"quan",
    data(){
      return{
        peopleNum:0
      }
    },
    created(){
      this.login()
    },
    methods:{
      login () {
        this.url = "api/senderCount.php"
        console.log(this.url )
        this.$ajax.autoService
            .login(this.url)
            .then((res) => {
              this.peopleNum = res.data
            }, (res) => {
                console.log("error")
                this.REQUIRE = true;
            })
       },
    },
    components:{
      'quanList':QuanList
    }
  }
</script>

<style lang="stylus">
  .q_page
    .quanUserWrapper
      width: 100%
      height: 224px
      position: relative
      background:url(../../images/quan_banner_bg.jpg)no-repeat left top
      background-size:100% 224px
      .userWrapper
        position: relative
        z-index: 1
        padding: 40px 0px 0 30px
        display: flex
        .quanfans
          padding-left: 140px
          color: #fff
          font-size: 42px
          padding-top: 24px
          .quanfans2
            font-size: 28px
            color: #e5e5e5
        .quanfansNum
          width: 224px
          height: 92px
          background: linear-gradient(to right, #ff8300, #ff4600);
          border-radius: 46px 0 0 46px
          position: absolute
          right: 0px
          top: 60px
          display:flex
          .quanfansThumb
            width: 64px
            height: 64px
            background: rgba(255, 255, 255, 0.15)
            border-radius: 32px
            margin-left: 15px
            margin-top: 15px
            line-height: 64px
            text-align:center
            .icon-thumb
              background-image: linear-gradient(to bottom, #fff, #d3ad93)
              -webkit-background-clip: text
              -webkit-text-fill-color: transparent
          .quanfansOrder
            color: #fff
            flex: 0 0 134px
            padding-top: 20px
            padding-left: 14px
            box-sizing: border-box
            text-align: right;
            line-height:30px
  </style>



// WEBPACK FOOTER //
// src/components/quan/quan.vue